<template>
  <nav class="navbar navbar-expand navbar-light bg-white mb-3">
    <button type="button" class="btn btn-sidebar" @click="showSidebar">
      <i class="icon-menu"></i>
    </button>
    <div class="navbar-brand text-primary">
      {{ title }}
    </div>
  </nav>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'Navbar',
  data () {
    return {
      title: null,
      locations: {
        'home': 'Bem-vindo ao Antifraude',
        'occurrences': 'Ocorrências',
        'occurrences-detail': 'Análise de ocorrência',
        'sellers': 'Cadastros',
        'sellers-detail': 'Dados do cadastro'
      }
    }
  },
  methods: {
    showSidebar () {
      $('.app-sidebar').sidebar('show')
    }
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler (route) {
        this.title = this.locations[route.name]
      }
    }
  }
}
</script>
